module.exports = __webpack_public_path__ + "static/media/icon-graphic-coffee.3c800ded.svg";